<template>
    <master-layout>

        <div class="breadcamb_box">
            <div>
                <h4 class="page-title m-b-0"><i class="ti-plug"></i> {{ $t('integrations') }}</h4>
                <ol class="breadcrumb">
                    <li><router-link :to="{ name: 'integrations.index' }">{{ $t('integrations') }}</router-link></li>
                    <li class="active">RD Station</li>
                </ol>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <form @submit.prevent="store" novalidate>
            <div class="card-box icon_integration">
                <div class="bar-widget m-b-15">
                    <div class="table-box">
                        <div class="table-detail w_60">
                            <div class="iconbox">
                                <i class="ti-id-badge"></i>
                            </div>
                        </div>
                        <div class="table-detail">
                            <label class="label label-default pull-right" v-if="isEnabled">{{ $t('activated') }}</label>
                            <label class="label label-danger pull-right" v-if="!isEnabled">{{ $t('inactive') }}</label>
                            <h5 class="m-t-0 m-b-5 d_inline_b">
                                <b>RD Station</b>
                                <label class="label label-warning m-l-5 m-b-0 pull-right">Beta</label>
                            </h5>
                            <p class="m-b-5 text-muted">{{ $t('_integrations.description_rd-station') }}</p>
                        </div>
                    </div>
                </div>
                <p v-html="$t('_integrations.rd_station.line_01')"></p>
                <div class="alert alert-danger t_center m-0" v-if="!isEnabled && !member.is_admin">{{ $t('_integrations.mail_trap.line_14') }}</div>
                <div class="alert alert_default m-0">
                    <strong class="show m-b-5">{{ $t('attention') }}! </strong>
                    <ul>
                        <li>{{ $t('_integrations.rd_station.line_02') }}</li>
                        <li>{{ $t('_integrations.rd_station.line_03') }}</li>
                        <li>{{ $t('_integrations.rd_station.line_04') }} <a href="/incoming" target="_blank" class="bold">{{ $t('incoming_deals') }}</a>.</li>
                    </ul>
                </div>
                <div class="clearfix" v-if="member.is_admin">
                    <hr>
                    <div v-if="member.is_admin">
                        <h4 class="header-title m-t-0 m-b-5 text-dark">{{ $t('tokens') }}</h4>
                        <p class="m-b-20">{{ $t('_integrations.rd_station.line_05') }}</p>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <label class="input-group" :class="{ 'has-error': errors['content.public_token'] }">
                                    <input type="text" v-pml-focus v-model="record.content.public_token" class="form-control" :placeholder="$t('public_token')">
                                    <span class="input-group-addon">{{ $t('public_token') }}</span>
                                </label>
                                <span class="error" v-if="errors['content.public_token']">{{ errors['content.public_token'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <label class="input-group" :class="{ 'has-error': errors['content.private_token'] }">
                                    <input type="text" v-pml-focus v-model="record.content.private_token" class="form-control" :placeholder="$t('private_token')">
                                    <span class="input-group-addon">{{ $t('private_token') }}</span>
                                </label>
                                <span class="error" v-if="errors['content.private_token']">{{ errors['content.private_token'][0] }}</span>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-12 t_right">
                            <a href="#" @click.prevent="inactivate" class="btn btn-danger pull-left" v-if="isEnabled" v-pml-block="isDestroying">{{ $t('inactivate') }}</a>
                            <button type="submit" class="btn btn-default" v-if="isEnabled" v-pml-block="isSaving">{{ $t('update') }}</button>
                            <button type="submit" class="btn btn-default" v-else v-pml-block="isSaving">{{ $t('activate') }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="member.is_admin">
                <div class="card-box" v-if="record.key">
                    <h4 class="header-title m-t-0 m-b-5 text-dark"><i class="fa fa-exclamation-triangle text-warning"></i> {{ $t('attention') }}!</h4>
                    <p class="m-b-20">{{ $t('_integrations.rd_station.line_06') }}:</p>
                    <div class="input-group">
                        <input class="form-control input_search" :value="`https://api.pumpmylead.com/integrations/rd-station/webhook/${record.key}`" readonly>
                        <span class="input-group-btn" v-clipboard="`https://api.pumpmylead.com/integrations/rd-station/webhook/${record.key}`" @success="handleSuccess()">
                            <span class="btn btn-primary" v-pml-tooltip="$t('copy')"><i class="fa fa-copy"></i></span>
                        </span>
                    </div>
                </div>
                <div class="card-box">
                    <h4 class="header-title m-t-0 m-b-20 text-dark">{{ $t('set_up_the_incoming_leads') }}</h4>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 m-b-15" :class="{ 'has-error': errors['content.source_id'] }">
                            <h5 class="m-b-5"><b>{{ $t('source') }}</b></h5>
                            <pml-select v-model="record.content.source_id" :options="sources"></pml-select>
                            <span class="error" v-if="errors['content.source_id']">{{ errors['content.source_id'][0] }}</span>
                        </div>
                        <div class="col-xs-12 col-sm-6 m-b-15" :class="{ 'has-error': errors['content.segment_id'] }">
                            <h5 class="m-b-5"><b>{{ $t('segment') }}</b></h5>
                            <pml-select v-model="record.content.segment_id" :options="segments"></pml-select>
                            <span class="error" v-if="errors['content.segment_id']">{{ errors['content.segment_id'][0] }}</span>
                        </div>
                        <div class="col-xs-12 col-sm-6 m-b-15" :class="{ 'has-error': errors['content.pipeline_step_id'] }">
                            <h5 class="m-b-5"><b>{{ $t('pipeline') }}</b></h5>
                            <pml-select-group v-model="record.content.pipeline_step_id" :options="pipelines" group-values="steps" group-label="name" class="select_pipeline"></pml-select-group>
                            <span class="error" v-if="errors['content.pipeline_step_id']">{{ errors['content.pipeline_step_id'][0] }}</span>
                        </div>
                        <div class="col-xs-12 col-sm-6 m-b-15" :class="{ 'has-error': errors['content.follower_id'] }">
                            <h5 class="m-b-5"><b>{{ $t('follower') }}</b></h5>
                            <pml-select-members v-model="record.content.follower_id" :remove-from-options="record.content.member_id" :only-active="true" :only-follow="true"></pml-select-members>
                            <span class="error" v-if="errors['content.follower_id']">{{ errors['content.follower_id'][0] }}</span>
                        </div>
                    </div>
                    <hr class="m-b-30">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-4 m-b-15" :class="{ 'has-error': errors['content.auto_assign'] }">
                            <h5 class="m-t-0 m-b-5"><b>{{ $t('auto_distribution') }}</b></h5>
                            <small class="show text-muted m-b-10">{{ $t('distribute_leads_automatically') }}</small>
                            <pml-switch :value="record.content.auto_assign === 'yes'" @input="toggleActive()"></pml-switch>
                            <span class="error" v-if="errors['content.auto_assign']">{{ errors['content.auto_assign'][0] }}</span>
                        </div>
                        <div v-if="record.content.auto_assign === 'yes'" class="col-xs-12 col-sm-12 col-md-4 m-b-15" :class="{ 'has-error': errors['content.approach'] }">
                            <h5 class="m-t-0 m-b-5"><b>{{ $t('distribution_form') }}</b></h5>
                            <small class="show text-muted m-b-5">{{ $t('choose_how_the_system_should_distribute') }}</small>
                            <pml-select v-model="record.content.approach" :options="approaches"></pml-select>
                            <span class="error" v-if="errors['content.approach']">{{ errors['content.approach'][0] }}</span>
                        </div>
                        <div v-if="record.content.auto_assign === 'yes'" class="col-xs-12 col-sm-12 col-md-4 m-b-15" :class="{ 'has-error': errors['content.available_members'] }">
                            <h5 class="m-t-0 m-b-5"><b>{{ $t('available_members') }}</b></h5>
                            <small class="show text-muted m-b-5">{{ $t('available_members_desc') }}</small>
                            <pml-multiselect v-model="record.content.available_members" :options="activeMembers()" label="full_name"></pml-multiselect>
                            <span class="error" v-if="errors['content.available_members']">{{ errors['content.available_members'][0] }}</span>
                        </div>
                        <div v-if="record.content.auto_assign === 'no'" class="col-xs-12 col-sm-12 m-b-15" :class="{ 'has-error': errors['content.member_id'] }">
                            <h5 class="m-t-0 m-b-5"><b>{{ $t('consultant') }}</b></h5>
                            <small class="show text-muted m-b-5">{{ $t('who_will_be_in_charge_for_these_leads') }}</small>
                            <pml-select-members v-model="record.content.member_id" :only-active="true" :remove-from-options="record.content.follower_id"></pml-select-members>
                            <span class="error" v-if="errors['content.member_id']">{{ errors['content.member_id'][0] }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </master-layout>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { enableRdStationToken, updateRdStationToken, destroyRdStation } from 'services/integrations'
    import { isNil, find } from 'lodash'
    import { mapGetters } from 'vuex'
    import { trans } from 'utils/helpers/translation'
    import { integrationLink } from 'utils/helpers/sweet-alert'

    export default {
        name: 'RdStation',
        data () {
            return {
                record: {
                    content: {
                        available_members: [],
                        public_token: null,
                        private_token: null,
                        member_id: null,
                        auto_assign: 'no',
                        approach: null,
                        source_id: null,
                        segment_id: null,
                        pipeline_step_id: null
                    },
                    key: null
                },
                isSaving: false,
                isDestroying: false,
                errors: []
            }
        },
        metaInfo () {
            return {
                title: trans('integrations') + ' | Rd Station'
            }
        },
        computed: {
            ...mapGetters({
                'integrations': 'getIntegrations',
                'member': 'getMember',
                'activeMembers': 'getActiveMembers',
                'sources': 'getSources',
                'fieldOptions': 'getDealFields',
                'segments': 'getSegments',
                'pipelines': 'getPipelines',
                'approaches': 'getIntegrationIncomingApproaches'
            }),
            isEnabled () {
                return typeof this.record !== 'undefined' && !isNil(this.record.id)
            },
            getRdIntegration () {
                return find(this.integrations, {provider: 'RdStation'})
            }
        },
        mounted () {
            if (!['premium_power_sales'].includes(this.tenant.stripePlan))
                this.$router.push({ name: 'error.404' })
            if (!isNil(this.getRdIntegration))
                this.record = this.getRdIntegration

            if (this.record.content.auto_assign === 'yes' && isNil(this.record.content.available_members))
                this.record.content.available_members = this.activeMembers().map((item) => item.id)
        },
        methods: {
            store () {
                this.isSaving = true
                this.request(this.record)
                    .then((data) => {
                        this.errors = []
                        this.getResponse()
                        this.record = data.rdIntegration || data.data
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            },
            handleSuccess () {
                Notify.info(trans('info_added_to_your_clipboard'))
            },
            inactivate () {
                this.isDestroying = true
                destroyRdStation(this.record.id)
                    .then(() => {
                        this.errors = []
                        Notify.info(trans('_integrations.deactivate'))
                        this.record.content = {
                            available_members: [],
                            public_token: null,
                            private_token: null,
                            member_id: null,
                            source_id: null,
                            segment_id: null,
                            pipeline_step_id: null
                        }
                        this.record.key = null
                        this.record.id = null
                    })
                    .catch(error => {
                        this.errors = error.response.data
                    })
                    .then(() => { this.isDestroying = false })
            },
            request (payload) {
                return this.isEnabled ? updateRdStationToken(payload.id, payload) : enableRdStationToken(payload)
            },
            getResponse () {
                return this.isEnabled ? Notify.success(trans('successfully_updated')) : integrationLink()
            },
            toggleActive () {
                if (this.record.content.auto_assign === 'yes') {
                    this.record.content.auto_assign = 'no'
                } else {
                    this.record.content.auto_assign = 'yes'
                    this.record.content.available_members = this.activeMembers().map((item) => item.id)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/providers/rd_station/Main.vue